import { Campaign, Collab, draftLockReleased } from '@foodfluence/shared';

const hasUgcContentSignals = (campaign?: Campaign, collab?: Collab): boolean => {
  if (collab?.contentRequirements && Object.keys(collab.contentRequirements).length > 0) {
    return true;
  }
  if (collab?.content && Object.keys(collab.content).length > 0) {
    return true;
  }
  if (campaign?.contentRequirements && Object.keys(campaign.contentRequirements).length > 0) {
    return true;
  }
  return false;
};

/**
 * Determines if a campaign requires brand review/approval before content goes live.
 * When `collab` is provided, uses collab snapshot / UGC content in addition to campaign.
 */
export const requiresBrandReview = (campaign?: Campaign, collab?: Collab): boolean => {
  // Stamped at acceptance on go-live collabs: a later draft-toggle flip doesn't relabel them, except
  // drafts turned off before redemption (draftLockReleased), as the backend.
  if (collab?.contentDeadlineKind) return collab.contentDeadlineKind === 'draft' && !draftLockReleased(campaign, collab);
  if (!campaign) return false;

  const hasContentRequirements = hasUgcContentSignals(campaign, collab);

  if (hasContentRequirements) {
    return true;
  }

  if (!campaign.requireDraftApproval) {
    return false;
  }

  return true;
};